import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, MapPin, Phone, Send } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Navbar";

const Footer = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Messaggio inviato! Ti ricontatteremo presto.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <footer id="contatti" className="bg-[#050505] border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-16">
          <div>
            <Logo />
            <p className="text-white/60 mt-6 max-w-md leading-relaxed">
              Ditta a conduzione familiare al vostro servizio per studiare la soluzione più
              adatta alle vostre esigenze, con autisti qualificati e autobus da 4 a 54 persone.
            </p>
            <div className="mt-8 space-y-4 text-white/80">
              <div className="flex items-start gap-3">
                <MapPin className="text-[#FFF200] shrink-0 mt-1" size={18} />
                <span>Contrada Malde N° 27 — Vietri di PZ 85058 (PZ)</span>
              </div>
              <a
                href="mailto:cardilloviaggi@gmail.com"
                data-testid="footer-email"
                className="flex items-center gap-3 hover:text-[#FFF200] transition-colors"
              >
                <Mail className="text-[#FFF200]" size={18} /> cardilloviaggi@gmail.com
              </a>
              <a
                href="tel:+393463710318"
                data-testid="footer-phone"
                className="flex items-center gap-3 hover:text-[#FFF200] transition-colors"
              >
                <Phone className="text-[#FFF200]" size={18} /> +39 346 3710318
              </a>
              <p className="text-white/40 text-sm pt-2">
                Cardillo Viaggi di Cardillo Nicola — P. IVA 02049030766
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-display font-semibold mb-6">Richiedi un preventivo</h3>
            <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
              <div className="grid sm:grid-cols-2 gap-4">
                <input
                  required
                  data-testid="contact-name"
                  placeholder="Nome"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full bg-[#121212] border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-white/40 focus:border-[#FFF200] focus:outline-none transition-colors"
                />
                <input
                  data-testid="contact-phone"
                  placeholder="Telefono"
                  value={form.phone}
                  onChange={(e) => setForm({ ...form, phone: e.target.value })}
                  className="w-full bg-[#121212] border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-white/40 focus:border-[#FFF200] focus:outline-none transition-colors"
                />
              </div>
              <input
                required
                type="email"
                data-testid="contact-email"
                placeholder="Email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full bg-[#121212] border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-white/40 focus:border-[#FFF200] focus:outline-none transition-colors"
              />
              <textarea
                required
                rows={4}
                data-testid="contact-message"
                placeholder="Raccontaci il tuo viaggio o evento..."
                value={form.message}
                onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full bg-[#121212] border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-white/40 focus:border-[#FFF200] focus:outline-none transition-colors resize-none"
              />
              <button
                type="submit"
                disabled={sending}
                data-testid="contact-submit"
                className="flex items-center gap-2 bg-[#FFF200] text-black font-semibold px-6 py-3 rounded-full hover:bg-[#FFF200]/90 transition-colors disabled:opacity-60"
              >
                <Send size={16} /> {sending ? "Invio..." : "Invia richiesta"}
              </button>
            </form>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Cardillo Viaggi. Tutti i diritti riservati.
          </p>
          <a
            href="/login"
            data-testid="footer-admin-link"
            className="text-white/30 text-xs hover:text-[#FFF200] transition-colors"
          >
            Area Riservata
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
